// 对某个对象的验证方法

// 基本类类型验证对象
const types = {
  number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof (value) === 'number';
  },
  integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float(value) {
    return types.number(value) && !types.integer(value);
  },
  array(value) {
    return Array.isArray(value);
  },
  object(value) {
    return typeof (value) === 'object' && !types.array(value);
  },
  method(value) {
    return typeof (value) === 'function';
  },
  boolean(value) {
    return typeof (value) === 'boolean';
  },
  string(value) {
    return typeof (value) === 'string';
  }
}

/**
  * 验证基本类型是否合法
  * @params {object} rule 当前的规则对象
  * @params {object|string|array|number} value 验证的值
  */
function type(rule, value) {
  const custom = ['integer', 'float', 'array', 'object',
    'method', 'number', 'boolean', 'string'];
  const ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      return rule.message
    }
  }
}

/**
  * 验证范围
  * @params {object} rule 当前的规则对象
  * @params {object|string|array|number} value 验证的值
  * @params {object} option 其他选项
  * @return {string}
  */
function range(rule, value, option) {
  const len = typeof rule.len === 'number';
  const min = typeof rule.min === 'number';
  const max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  const spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  let val = value;
  let key = null;
  const num = typeof (value) === 'number';
  const str = typeof (value) === 'string';
  const arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      return option.message;
    }
  } else if (min && !max && val < rule.min) {
    return option.message;
  } else if (max && !min && val > rule.max) {
    return option.message;
  } else if (min && max && (val < rule.min || val > rule.max)) {
    return option.message;
  }
}

/**
  * 判断是否必须不为空或undefined
  * @params {object} rule 当前的规则对象
  * @params {object|string|array|number} value 验证的值
  * @params {object} source 需要验证的源对象
  * @params {string} type 对象的类型
  * @params {object} option 其他选项
  * @return {string}
  */
function required(rule, value, source, type, option) {
  if (rule.required && !source.hasOwnProperty(rule.field) && isEmptyValue(value, type || rule.type)) {
    return option.message;
  }
}

/**
  * 判断当前值是否等于value
  * @params {object} rule 当前的规则对象
  * @params {object|string|array|number} value 验证的值
  * @return {string}
  */
function isValue(rule, value) {
  let valType = getTypeof(value);
  if (valType === undefined) {
    return false;
  }
  if (valType === 'object' || valType === 'function') {
    return false;
  }
  return rule.value === value;
}

// 是否空对象
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

/**
  * 判断该对象是否为空对象
  * @params {object|string|array|number} value 需要判断的对象
  * @params {string} type 对象的类型
  * @return {boolean}
  */
function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (typeof value === 'string' && !value) {
    return true;
  }
  if (type === 'object' && typeof value === 'object' && isEmptyObject(value)) {
    return true;
  }
  return false;
}

/**
  * 判断是哪个对象类型
  * @params {string} value 需要判断的对象
  * @return {string}
  */
function getTypeof(value) {
  let type = '';
  for (let key in types) {
    let valType = types[key](value);
    if (valType) {
      type = key;
      break;
    }
  }
  return type;
}

// 默认返回的message
let defaultMessage = {
  types: {
    message: '%s 不是 %e',
  },
  required: {
    message: '%s 为空',
  },
  range: {
    message: '%s 不合法',
  }
}

// test data
// let rules = {
//   isInServiceTime: [
//     { type: 'boolean', value: true, message: '不在营业时间' },
//   ],
//   isSoldOut: [
//     { required: true, type: 'boolean', message: '该餐品已售罄' },
//   ],
//   hasInventory: [
//     {
//       validator: (rule, value, source, callback) => {
//         if (value) {
//           if (source.inventoryNum === 0 || num > source.inventoryNum) {
//             callback(new Error('该餐品已售罄'));
//           } else {
//             callback();
//           }
//         }
//       }
//     }
//   ]
// }

// let rulesData = {
//   isInServiceTime: false,
//   isSoldOut: false,
//   hasInventory: 0,
//   inventoryNum: 0
// }


/**
  * 判断是否必须不为空或undefined
  * @params {object} rules 规则对象集合
  * @params {object|string|array|number} value 验证的值
  * @params {object} source 需要验证的源对象
  * @return {array}
  */
function validator(rules, source) {
  let error = [];
  for (let key in rules) {
    let rule = rules[key];
    rule.field = key;
    if (source[key] === undefined) {
      continue;
    }
    let value = source[key];
    for (let i = 0;i < rule.length; i ++) {
      if (rule[i].hasOwnProperty('required')) {
        let message = '';
        let valType = rule[i].type || getTypeof(value);
        if (rule[i].message !== undefined) {
          message = rule[i].message;
        } else {
          message = defaultMessage.required.replace('%s', valType);
        }
        let result = required(rule[i], value, source, valType, { message });
        if (result !== undefined) {
          error.push(result);
        }
      }
      if (rule[i].hasOwnProperty('type')) {
        let message = '';
        if (rule[i].message !== undefined) {
          message = rule[i].message;
        } else {
          message = defaultMessage.types.replace('%s', rule[i].type);
        }
        let result = type(rule[i], value, { message });
        if (result !== undefined) {
          error.push(result);
        }
      }
      if (rule[i].hasOwnProperty('max') || rule[i].hasOwnProperty('min') || rule[i].hasOwnProperty('len')) {
        let valType = rule[i].type || getTypeof(value);
        let message = '';
        if (rule[i].message !== undefined) {
          message = rule[i].message;
        } else {
          message = defaultMessage.required.replace('%s', valType);
        }
        if (valType === 'boolean' || valType === 'function' || valType === 'object') {
          return;
        }
        let result = range(rule[i], value, { message });
        if (result !== undefined) {
          error.push(result);
        }
      }
      if (rule[i].hasOwnProperty('validator')) {
        let callback = (err = false) => { 
          if (typeof err === 'object') {
            error.push(err.message);
          } else if (typeof err === 'string') {
            error.push(err);
          }
        };
        rule[i].validator(rule[i], value, source, callback);
      }
      if (rule[i].hasOwnProperty('value')) {
        let message = '';
        if (rule[i].message !== undefined) {
          message = rule[i].message;
        } else {
          message = key + '的值不是' + rule[i].value;
        }
        if(isValue(rule[i], value)) {
          error.push(message);
        }
      }
      if (error.length) {
        break;
      }
    }
    if (error.length) {
      break;
    }
  }
  return error;
}

export default validator;


// WEBPACK FOOTER //
// ./../../plugins/cart/veriflcation.js